import moment from "moment";
import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import ActionsCell from "./ActionsCell";
import { BillType } from "./bill-types";

const useBillsTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Client Name",
      accessor: "clientName",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Provided Item",
      accessor: "items",
      className: "min-w-[150px]",
      Cell: ({
        row: {
          original: { service },
        },
      }: CellProps<BillType>) => (
        <div className="flex items-center justify-center">
          <TextCell value={`${service[0]}`} />
          {service.length > 1 && (
            <span className="text-[#0C8CE9]">
              +<span>{service.length}</span> etc
            </span>
          )}
        </div>
      ),
    },
    {
      Header: "Bill date and time",
      accessor: "billingDate",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<BillType>) => (
        <TextCell value={moment(value).format("DD MMM YYYY h:mm A")} />
      ),
    },
    {
      Header: "Amount (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<BillType>) => (
        <TextCell value={value.toFixed(2)} />
      ),
    },
    {
      Header: "Rating",
      accessor: "rating",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Staff",
      accessor: "staff",
      className: "min-w-[150px]",
      Cell: ({
        row: {
          original: { staff },
        },
      }: CellProps<BillType>) => (
        <div className="flex items-center justify-center">
          <TextCell value={`${staff[0]}`} />
          {staff.length > 1 && (
            <span className="text-[#0C8CE9]">
              +<span>{staff.length}</span> etc
            </span>
          )}
        </div>
      ),
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<BillType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useBillsTableColumns;
